import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Spinner,
  Alert,
  Breadcrumb,
} from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import { useAuth } from "../../context/AuthContext";
import colors from "../../constants/colors";
import { FaCalendarAlt, FaPen } from "react-icons/fa";
import SEO from '../../components/SEO';

const ServiceDetailPage = () => {
  const { id } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [metadata, setMetadata] = useState(null);
  
  const { user } = useAuth();

  useEffect(() => {
    const fetchServiceDetails = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`/service/${id}`);
        const metadataResponse = await axiosInstance.get(`/seo/metadata/service/${id}`);
        setService(response);
        setMetadata(metadataResponse);
        setError("");
      } catch (err) {
        console.error("Error fetching service details:", err);
        setError(
          "Erro ao carregar detalhes do serviço. Por favor tente novamente mais tarde."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchServiceDetails();
  }, [id]);

  if (loading) {
    return (
      <Container className="my-5 text-center">
        <Spinner animation="border" role="status" style={{ color: colors.secondary }} />
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="my-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  if (!service) {
    return (
      <Container className="my-5">
        <Alert variant="warning">Serviço não encontrado</Alert>
      </Container>
    );
  }

  return (
    <>
      <SEO
        title={service.name}
        description={service.description}
        image={service.image}
        structuredData={metadata}
      />
      <Container className="my-5">
        <Breadcrumb className="mb-4">
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/servicos" }}>
            Serviços
          </Breadcrumb.Item>
          <Breadcrumb.Item active>{service.name}</Breadcrumb.Item>
        </Breadcrumb>

        <Row>
          <Col lg={6} className="mb-4">
            <div
              className="d-flex justify-content-center align-items-center bg-light"
              style={{ height: "400px", width: "100%" }}
            >
              <img
                src={service.image}
                alt={service.name}
                style={{
                  maxHeight: "380px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </Col>

          <Col lg={6}>
            <h1 className="mb-3">{service.name}</h1>

            <div
              className="mb-4"
              style={{
                color: colors.textGray,
                fontSize: "1.1rem",
                lineHeight: "1.5",
                overflowWrap: "break-word"
              }}
            >
              <p className="mb-2">{service.description}</p>
            </div>

            <div className="d-grid gap-2">
              <Button
                href={service.schedule_link}
                target="_blank"
                rel="noopener noreferrer"
                size="lg"
                style={{
                  backgroundColor: colors.secondary,
                  borderColor: colors.secondary,
                  color: colors.light,
                }}
              >
                <FaCalendarAlt className="me-2" />
                Agendar Serviço
              </Button>
            </div>

            {/* Admin edit button */}
            {user && user.isAdmin && (
              <div className="mt-4">
                <Button
                  as={Link}
                  to={`/admin-dashboard/edit-service/${service.id}`}
                  style={{
                    backgroundColor: colors.dark,
                    borderColor: colors.dark,
                    color: colors.primary,
                  }}
                >
                  <FaPen className="me-2" />
                  Editar Serviço
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ServiceDetailPage; 